
export default {
    api: {

        url: 'https://devapi.datedish.com/datedish/api/v1/',
        // url: 'http://stagapi.datedish.com/datedish/api/v1/',
        // url: 'https://devapi.datedish.com/datedish/api/v1/',

        mode: 'cors'
    },
    config: {
    }
}
